import * as React from 'react'

function SvgAo(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path d="M0 0h450v300H0z" />
			<path fill="#ce1126" d="M0 0h450v150H0z" />
			<g fill="#f9d616">
				<path d="M231.115 91.82a58.5 58.5 0 11-43.199 103.424l-8.558 10.441a72 72 0 1053.168-127.291z" />
				<g id="ao_svg__b">
					<path
						id="ao_svg__a"
						d="M302.624 142.355c.501 5.085.501 10.206 0 15.29l-14.927-1.47a63.002 63.002 0 000-12.35z"
					/>
					<use xlinkHref="#ao_svg__a" transform="rotate(22.5 225 150)" />
					<use xlinkHref="#ao_svg__a" transform="rotate(45 225 150)" />
				</g>
				<use xlinkHref="#ao_svg__b" transform="rotate(-67.5 225 150)" />
				<use xlinkHref="#ao_svg__b" transform="rotate(67.5 225 150)" />
				<path d="M199.324 114.656h51.352l-41.543 30.184L225 96l15.867 48.84zM287.879 216.315c3.838 3.714 9.006 7.375 12.755 10.702 3.748 3.327 6.62 6.093 8.945 9.872 3.407 5.539-.419 11.812-5.724 8.13-2.87-1.991-4.672-7.367-9.067-11.815-3.255-2.771-5.82-5.677-14.002-7.078-.393-.068-.508-.898-.2-1.26z" />
				<path
					fill="#000"
					d="M231.36 197.845l20.248 11.972 4.401 17.079 23.24-1.761 10.213-11.972-37.854-26.234-20.247 10.916z"
				/>
				<path d="M279.663 223.69c-26.035-17.315-42.59-26.664-67.542-40.85-9.801-5.574-25.023-19.583-13.016-43.02.756 15.386 61.569 57.622 87.265 75.987z" />
				<path
					fill="none"
					stroke="#000"
					strokeWidth={1.5}
					strokeLinecap="round"
					d="M216.086 167.52c20.045 18.89 45.29 34.301 67.812 51.335"
				/>
				<circle id="ao_svg__c" cx={290.4} cy={222.297} r={1.008} fill="#000" />
				<use xlinkHref="#ao_svg__c" x={7.42} y={6.466} />
				<use xlinkHref="#ao_svg__c" x={13.938} y={13.09} />
			</g>
		</svg>
	)
}

export default SvgAo
